module.exports = __webpack_public_path__ + "img/illustrator-noData.989fd9a1.svg";